//src/styles/shape.js
const shape = {
  borderRadius: 8,
  borderRadiusSmall: 4,
  borderRadiusLarge: 12,
  borderRadiusXLarge: 16,
  // Common border radii
  pill: 9999, // For pills and chips
  circle: "50%", // For circular elements
};

export default shape;